<template>
  <main class="container__brand">
    <div class="brand__header">
      <router-link to="/brandMaison" class="go__back">
        <img src="@/assets/img/brands/back.svg" alt="icon" />
      </router-link>
      <img class="brand__logo" src="@/assets/img/brands/te/tee.svg" alt="" />
      <img class="brand__bcg" src="@/assets/img/brands/te/tee.svg" alt="" />
      <router-link to="/brandBasilur" class="go__back__right">
        <img src="@/assets/img/brands/back.svg" alt="icon" />
      </router-link>
    </div>

    <div class="container__clm">
      <Carousell
        :images="[
          require('../../assets/img/brands/te/p1.png'),
          require('../../assets/img/brands/te/p2.png'),
          require('../../assets/img/brands/te/p3.png'),
          require('../../assets/img/brands/te/p4.png'),
          require('../../assets/img/brands/te/p5.png'),
          require('../../assets/img/brands/te/p6.png'),
        ]"
      />
      <div class="brand__text">
        <div class="text">
          <p>{{ $t('brands.te.desc') }}</p>
          <br />
          <p class="continets__text">{{ $t('brands.te.desc2') }}</p>
        </div>

        <div class="brand__continents">
          <img src="@/assets/img/brands/world.svg" alt="" />
        </div>
      </div>
    </div>
    <Button @click="redirect('https://coffeemall.bg/')" class="btn" type="button">{{ $t('buttons.button4') }}</Button>
  </main>
</template>

<script>
import Button from '@/components/Button';
import Carousell from '@/components/Carousell';
export default {
  components: {
    Button,
    Carousell,
  },
  data() {
    return {};
  },
  methods: {
    redirect: function (link, target = '_blank') {
      window.open(link, target);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/scss/base.scss';
@import '@/scss/brands.scss';
.container__brand {
  background: #5a5b5e 0% 0% no-repeat padding-box;
}
</style>